/* esm.sh - applesauce-common@5.2.0/helpers/relay-list */
export * from "/*applesauce-common@5.2.0/esnext/helpers/relay-list.mjs";
